import { useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import PageHero from "@/components/bakery/PageHero";
import { RegisterArt } from "@/components/bakery/Art";
import MappingDialog from "@/components/common/MappingDialog";
import { ChannelChip } from "@/components/common/Chips";
import { inputCls } from "@/components/common/Field";
import { Loading, PrimaryBtn } from "@/components/common/ui";
import { useApi } from "@/lib/useApi";
import { api, errMsg } from "@/lib/api";
import { cn } from "@/lib/utils";

const PF = { shopee: "Shopee", tokopedia: "Tokopedia/TikTok" };

export default function MasterMapping() {
  const { data, loading, reload } = useApi("/mappings");
  const { data: products } = useApi("/products");
  const [pf, setPf] = useState("");
  const [q, setQ] = useState("");
  const [edit, setEdit] = useState(undefined);
  const list = (data || []).filter((m) => (!pf || m.platform === pf) && (!q || `${m.raw_name} ${m.raw_variation} ${m.product_name}`.toLowerCase().includes(q.toLowerCase())));
  const remove = async (m) => {
    if (!window.confirm(`Hapus mapping "${m.raw_name}"?`)) return;
    try { await api.delete(`/mappings/${m.id}`); toast.success("Mapping dihapus"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="master-mapping-page">
      <PageHero testid="mapping-hero" eyebrow="Master" title="Mapping Marketplace" Art={RegisterArt} compact
        desc="Nama produk + variasi di Shopee / Tokopedia → produk master. Dipakai otomatis saat import."
        actions={<PrimaryBtn onClick={() => setEdit(null)} data-testid="add-mapping-btn"><Plus className="h-4 w-4" /> Tambah Mapping</PrimaryBtn>} />
      <div className="mb-4 flex flex-col gap-3 sm:flex-row">
        <div className="flex rounded-md border-2 border-ink bg-white p-1">
          {[["", "Semua"], ["shopee", "Shopee"], ["tokopedia", "Tokopedia"]].map(([k, l]) => (
            <button key={k} onClick={() => setPf(k)} className={cn("press rounded px-4 py-2 text-sm font-semibold", pf === k && "bg-ink text-white")} data-testid={`mapping-filter-${k || "all"}`}>{l}</button>
          ))}
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nama produk…" className={cn(inputCls, "sm:w-80")} data-testid="mapping-search" />
      </div>
      {loading && !data ? <Loading /> : (
        <div className="overflow-x-auto rounded-xl border border-zinc-200 bg-white">
          <table className="dense-table w-full min-w-[900px]" data-testid="mapping-table">
            <thead><tr><th>Platform</th><th>Nama Produk (raw)</th><th>Variasi</th><th>→ Master</th><th /></tr></thead>
            <tbody>{list.map((m) => (
              <tr key={m.id}>
                <td><ChannelChip channel={PF[m.platform]} /></td>
                <td className="max-w-[420px] whitespace-normal">{m.raw_name}</td>
                <td>{m.raw_variation || <span className="text-zinc-400">semua</span>}</td>
                <td className="font-semibold">{m.product_name}</td>
                <td className="flex gap-1.5">
                  <button onClick={() => setEdit(m)} className="press grid h-8 w-8 place-items-center rounded border border-zinc-300 hover:border-ink" data-testid={`edit-mapping-${m.id}`}><Pencil className="h-3.5 w-3.5" /></button>
                  <button onClick={() => remove(m)} className="press grid h-8 w-8 place-items-center rounded border border-zinc-300 hover:border-brand hover:text-brand" data-testid={`delete-mapping-${m.id}`}><Trash2 className="h-3.5 w-3.5" /></button>
                </td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
      <MappingDialog open={edit !== undefined} initial={edit} products={products} onClose={() => setEdit(undefined)} onSaved={() => { setEdit(undefined); reload(); }} />
    </div>
  );
}
